import { Badge } from '@/components/ui/badge';
import { SessionFeedbackIssue, SessionFeedbackIssueDetails } from '@airreading/common/data';

interface FeedbackIssueBadgeProps {
  feedbackIssue: SessionFeedbackIssue;
}

export const FeedbackIssueBadge = ({ feedbackIssue }: FeedbackIssueBadgeProps) => {
  return (
    <Badge className="bg-teal-400 hover:bg-teal-500 cursor-default">
      {SessionFeedbackIssueDetails[feedbackIssue].label}
    </Badge>
  );
};
